export const renderEthnicity = (racialHeritage: string) => {
	if (racialHeritage === 'I do not wish to disclose') {
		return 'Undisclosed';
	} else {
		return racialHeritage;
	}
};

export const renderGender = (gender: 'F' | 'M') => {
	if (gender === 'F') {
		return 'Female';
	}
	if (gender === 'M') {
		return 'Male';
	}

	return '';
};

export const renderPreferredLanguage = (preferredLanguage: string) => {
	switch (preferredLanguage) {
		case 'AR':
			return 'Arabic';
		case 'ZH':
			return 'Chinese';
		case 'EN':
			return 'English';
		case 'FR':
			return 'French';
		case 'DE':
			return 'German';
		case 'IT':
			return 'Italian';
		case 'JA':
			return 'Japanese';
		case 'KO':
			return 'Korean';
		case 'RU':
			return 'Russian';
		case 'ES':
			return 'Spanish';
		case 'ZZ':
			return 'Other';
		default:
			return '';
	}
};

export const renderStatus = (status: string) => {
	if (status === 'LeaveOfAbsence') {
		return 'Leave of Absence';
	}

	return status;
};

export const renderTobaccoStatus = (person: { isCurrentSmoker: boolean; isPreviousSmoker: boolean }) => {
	if (person.isCurrentSmoker) {
		return 'Yes';
	} else {
		if (person.isPreviousSmoker) {
			return 'Previous';
		} else {
			return 'No';
		}
	}
};
